import { Checkbox, ListItemText } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

type FilterMenuProps = {
  filterName: string;
  option: string;
  isChecked: boolean;
  requiresTranslation: boolean;
};

export const FilterMenuItem = (props: FilterMenuProps) => {
  const { filterName, option, isChecked, requiresTranslation } = props;
  const { t } = useTranslation('search');

  return (
    <>
      <Checkbox checked={isChecked} color="success" />
      {requiresTranslation ? (
        <ListItemText
          primary={t(
            `filterOption.${filterName.toLocaleLowerCase()}.${option.toLocaleLowerCase()}`
          )}
          sx={{ color: '#6F7174' }}
        />
      ) : (
        <ListItemText primary={option} sx={{ color: '#6F7174' }} />
      )}
    </>
  );
};
